import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/markyctian/nes-design/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Explain } from 'docz';
import { Modal, Button, Text, Table } from '@components';
import { Props } from './config';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const TagVersion = makeShortcode("TagVersion");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "modal"
    }}>{`Modal`}</h2>
    <TagVersion component="Modal" mdxType="TagVersion" />
    <h2 {...{
      "id": "use-and-import"
    }}>{`Use and Import`}</h2>
    <Explain component="Modal" isCopyable mdxType="Explain" />
    <h2 {...{
      "id": "import-tips"
    }}>{`Import Tips`}</h2>
    <Text status="error" mdxType="Text">
  NES.css does not include any JavaScript. If you want to use dialog element other than Chrome, you need polyfill. 
    </Text>
    <Text status="error" mdxType="Text">
  官方未提供 dialog 的 polyfill，使用请注意浏览器兼容性。
    </Text>
    <h2 {...{
      "id": "case"
    }}>{`Case`}</h2>
    <Playground __position={3} __code={'() => {\n  const [visible, setVisible] = useState(false)\n  const [round, setRound] = useState(false)\n  const [theme, setTheme] = useState(\'\')\n  return (\n    <div>\n      <Button status=\"primary\" onClick={() => setVisible(true)}>\n        Open Modal\n      </Button>\n      <Button style={{ marginLeft: 10 }} onClick={() => setRound(!round)}>\n        Modal Round Control\n      </Button>\n      <Button\n        style={{ marginLeft: 10 }}\n        onClick={() => setTheme(theme ? \'\' : \'dark\')}\n      >\n        Modal Theme Control\n      </Button>\n      <Text style={{ marginTop: 10 }}>\n        Modal Attr: round: {String(round)} / theme: {theme}\n      </Text>\n      <Modal\n        visible={visible}\n        onCancel={() => setVisible(false)}\n        theme={theme}\n        round={round}\n        onOk={() => setVisible(false)}\n      >\n        {dialogRef => <div style={{ height: 50 }}> This is Modal Body</div>}\n      </Modal>\n    </div>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Explain,
      Modal,
      Button,
      Text,
      Table,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const [visible, setVisible] = useState(false);
        const [round, setRound] = useState(false);
        const [theme, setTheme] = useState('');
        return <div>
        <Button status="primary" onClick={() => setVisible(true)} mdxType="Button">
          Open Modal
        </Button>
        <Button style={{
            marginLeft: 10
          }} onClick={() => setRound(!round)} mdxType="Button">
          Modal Round Control
        </Button>
        <Button style={{
            marginLeft: 10
          }} onClick={() => setTheme(theme ? '' : 'dark')} mdxType="Button">
          Modal Theme Control
        </Button>
        <Text style={{
            marginTop: 10
          }} mdxType="Text">Modal Attr: round: {String(round)} / theme: {theme}</Text>
        <Modal visible={visible} onCancel={() => setVisible(false)} theme={theme} round={round} onOk={() => setVisible(false)} mdxType="Modal">
          {dialogRef => <div style={{
              height: 50
            }}> This is Modal Body</div>}
        </Modal>
      </div>;
      }}
    </Playground>
    <Playground __position={4} __code={'() => {\n  const [visible, setVisible] = useState(false)\n  return (\n    <div>\n      <Button status=\"primary\" onClick={() => setVisible(true)}>\n        Open Modal\n      </Button>\n      <Modal\n        visible={visible}\n        renderFooter={dialogElement => (\n          <Button block status=\"primary\" onClick={() => setVisible(false)}>\n            {\' \'}\n            Custom Footer{\' \'}\n          </Button>\n        )}\n      >\n        {dialogElement => (\n          <div style={{ height: 50 }}> This is Modal Body</div>\n        )}\n      </Modal>\n    </div>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Explain,
      Modal,
      Button,
      Text,
      Table,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Custom Modal" mdxType="Playground">
  {() => {
        const [visible, setVisible] = useState(false);
        return <div>
        <Button status="primary" onClick={() => setVisible(true)} mdxType="Button">
          Open Modal
        </Button>
        <Modal visible={visible} renderFooter={dialogElement => <Button block status="primary" onClick={() => setVisible(false)} mdxType="Button"> Custom Footer </Button>} mdxType="Modal">
          {dialogElement => <div style={{
              height: 50
            }}> This is Modal Body</div>}
        </Modal>
      </div>;
      }}
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <>
  {[Props.public].map(({
        columns,
        data,
        footer
      }) => <div style={{
        marginTop: 20
      }}>
        <Table theme="dark" columns={columns} data={data} footer={() => <div style={{
          height: 60,
          borderTop: '4px solid white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
              {footer}
            </div>} mdxType="Table" />
      </div>)}
    </>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      